import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d3b63690"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "news-content flex-start"
}
const _hoisted_2 = { class: "header-bg" }
const _hoisted_3 = ["title"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "header-text-icon" }, null, -1))
const _hoisted_5 = { class: "right-wrap" }
const _hoisted_6 = ["onClick", "onMouseenter"]
const _hoisted_7 = {
  key: 0,
  class: "icon iconfont icon-a-gonggao1x"
}
const _hoisted_8 = {
  key: 1,
  class: "news-type"
}
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "light-gray-font-color" }

import BigNoData from '@/components/no-data.vue';
import LazyImage from '@/components/lazy-image/lazy-image.vue';
import { goNewsDetail, getLink } from '@/lib/tools.js';
import { computed, PropType, ref, watch } from 'vue';

// const defaultNewsImg = 'https://srt-read-online.3ren.cn/basebusiness/material/20221102/16673627738023vUnoocsyi002.jpg'

export default /*#__PURE__*/_defineComponent({
  __name: 'news',
  props: {
    type: {
        type: String as PropType<'news' | 'notice'>,
        default: 'news',
    },
    data: {
        // 新闻咨询列表
        type: Array,
        default: () => [],
    },
    imgWidth: {
        type: String,
        default: '373px',
    },
    imgHeight: {
        type: String,
        default: '210px',
    },
    titleHoverColor: {
        type: String,
        default: '#2164c9',
    },
},
  setup(__props) {

const props = __props;

const defaultNewsImg =
    'https://srt-read-online.3ren.cn/basebusiness/material/20230323/1679552862182QSZQebLxir000.png';



// 当前激活的公告item
const activeInfo = ref({});

const getStyle = computed(() => {
    return `
    --img-width: ${props.imgWidth};
    --img-height: ${props.imgHeight};
    --title-hover-color: ${props.titleHoverColor};
    `;
});

// 跳转新闻详情页
function goDetail(info) {
    goNewsDetail(info, 'informationDetail');
}

function getDetailLink(info) {
    return getLink(info, 'informationDetail');
}

function onHover(info) {
    activeInfo.value = info;
}

watch(
    () => props.data,
    val => {
        if (val && val.length) {
            activeInfo.value = val[0];
        }
    },
    {
        deep: true,
        immediate: true,
    },
);

return (_ctx: any,_cache: any) => {
  const _directive_link = _resolveDirective("link")!

  return (_openBlock(), _createElementBlock("div", {
    class: "news-container",
    style: _normalizeStyle(_unref(getStyle))
  }, [
    (props.data && props.data.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "left-wrap pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (goDetail(activeInfo.value)))
          }, [
            _createVNode(LazyImage, {
              src: activeInfo.value.coverUrl || defaultNewsImg,
              "class-name": "news-img"
            }, null, 8, ["src"]),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("p", {
                class: "header overflow-ellipsis",
                title: activeInfo.value.contentTitle
              }, [
                _hoisted_4,
                _createElementVNode("span", null, _toDisplayString(activeInfo.value.contentTitle), 1)
              ], 8, _hoisted_3)
            ])
          ])), [
            [_directive_link, getDetailLink(activeInfo.value)]
          ]),
          _createElementVNode("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.contentId,
                class: _normalizeClass([
                        'news-item',
                        'flex-start',
                        'pointer',
                        {
                            active: item.contentId === activeInfo.value.contentId,
                            'notice-item': __props.type === 'notice',
                        },
                    ]),
                onClick: ($event: any) => (goDetail(item)),
                onMouseenter: ($event: any) => (onHover(item))
              }, [
                (__props.type === 'notice')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7))
                  : _createCommentVNode("", true),
                (item?.tag)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item.tag), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("p", {
                  class: "news-text overflow-ellipsis",
                  title: item.contentTitle
                }, [
                  _withDirectives((_openBlock(), _createElementBlock("span", null, [
                    _createTextVNode(_toDisplayString(item.contentTitle), 1)
                  ])), [
                    [_directive_link, getDetailLink(item)]
                  ])
                ], 8, _hoisted_9),
                _createElementVNode("p", _hoisted_10, _toDisplayString(item.publishTime), 1)
              ], 42, _hoisted_6))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createBlock(BigNoData, {
          key: 1,
          class: "mar-top49",
          url: "no-news@2x.png",
          info: "暂无内容，静等上新"
        }))
  ], 4))
}
}

})